import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import QuizResult from '../components/quiz/QuizResult'

const QuizResultPage = () => {
  return (
    <>
    <Navbar/>
    <QuizResult/>
    </>
  )
}

export default QuizResultPage